import mapboxgl from "mapbox-gl";

/**
 * Set a fit MapView MapBox on Dockyard from bbox compute on API
 * @param dockyardData
 * @returns {*|null}
 */
export const fitToBoundsDockyard = dockyardData => {
    let bounds
    try {
        if (dockyardData && dockyardData.bbox) {
            let coordinates = dockyardData.bbox.coordinates[0];

            bounds = coordinates.reduce(function (bounds, coord) {
                return bounds.extend(coord);
            }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
        }
    } catch (e) {
        console.log(e)
    }
    return bounds || null
}